// src/redux/feediscountSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_feediscount,
  add_feediscount,
  update_feediscount,
  delete_feediscount,
  get_feediscount_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  feediscount: [],
  feediscountlist:[],
  feediscountfilterlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
  },
};

// Async Thunks for API Calls
export const fetchfeediscountList = createAsyncThunk(
    'feediscount/fetchfeediscountlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_feediscount_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchfeediscount = createAsyncThunk(
  "feediscount/fetchfeediscount",
  async ({ page, page_size,school_id,filter_fields, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_feediscount(page, page_size,school_id,filter_fields,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createfeediscount = createAsyncThunk(
  "feediscount/createfeediscount",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_feediscount(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatefeediscount = createAsyncThunk(
  "feediscount/updatefeediscount",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_feediscount(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletefeediscount = createAsyncThunk(
  "feediscount/deletefeediscount",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_feediscount({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// feediscount Slice
const feediscountSlice = createSlice({
  name: 'feediscounts',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name} = action.payload;
      state.formData = { id, name};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
      };
    },
    setfeediscount(state, action) {
      state.feediscount = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchfeediscountList.fulfilled, (state, action) => {
        state.feediscountlist = action.payload.data;
      })
      .addCase(fetchfeediscountList.rejected, (state, action) => {
        state.feediscountlist = [];
      })
     
       // Fetch feediscount
       .addCase(fetchfeediscount.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchfeediscount.fulfilled, (state, action) => {
        state.loading = false;
        state.feediscount = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchfeediscount.rejected, (state, action) => {
        state.loading = false;
        state.feediscount = [];
        state.error = action.payload;
      })

      // Add feediscount
      .addCase(createfeediscount.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createfeediscount.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createfeediscount.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update feediscount
      .addCase(updatefeediscount.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatefeediscount.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatefeediscount.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete feediscount
      .addCase(deletefeediscount.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletefeediscount.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletefeediscount.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setfeediscount,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = feediscountSlice.actions;
export default feediscountSlice.reducer;
